import { BracketRow } from "./styles";
import {
  getNodesByDepth,
  getMaxDepth,
  getAllNodes,
  BracketGraph,
} from "model/Bracket/BracketGraph";
import { mapRowWithBracketLines } from "./BracketRow";
import { BracketMatchArgs } from "./BracketMatchArgs";

interface Props {
  bracketGraph: BracketGraph;
  compact: boolean;
  tournamentId: string;
  bracketMatchArgs?: BracketMatchArgs;
}

export const SingleElimBracket = ({
  bracketGraph,
  compact,
  tournamentId,
  bracketMatchArgs,
}: Props) => {
  const maxDepth = getMaxDepth(getAllNodes(bracketGraph.finalNodes));
  const nodesByDepth = getNodesByDepth(bracketGraph.finalNodes, false); // todo - deal with more than 1 final
  const { titleCells, nodeCells } = mapRowWithBracketLines(
    bracketMatchArgs,
    tournamentId,
    nodesByDepth,
    [],
    maxDepth,
    false,
    false,
    compact,
    0
  );

  return (
    <div style={{ padding: "10px", marginTop: "10px" }}>
      <BracketRow>{titleCells}</BracketRow>
      <BracketRow>{nodeCells}</BracketRow>
    </div>
  );
};
